import { Routes, Route } from 'react-router-dom';
import MatchingSummary from './components/matching/MatchingSummary';
import DraftReview from './components/matching/DraftReview';
import FinalReview from './components/matching/FinalReview';

function AppMatching() {
    return (
        <Routes>
            <Route path="matchingsummary" element={<MatchingSummary />} />
            <Route path="draftreview" element={<DraftReview />} />
            <Route path="finalreview" element={<FinalReview />} />
        </Routes>
    );
}

export default AppMatching;